import React, {forwardRef} from 'react'
import {createSlotRecipeContext} from '@chakra-ui/react3'
import recommendedProductsRecipe from './index.recipe'
import Slider from '../cms/slider'
import ProductTile from '../../../components/product-tile'
import {useIntl} from 'react-intl'

const {withContext, withProvider} = createSlotRecipeContext({
    recipe: recommendedProductsRecipe
})

const RecommendedProductsRoot = withProvider('div', 'root')
const RecommendedProductsLabel = withContext('h2', 'label')
const RecommendedProductsSliderImpl = forwardRef((props, ref) => {
    const {formatMessage} = useIntl()
    return (
        <Slider
            sliderLabel={formatMessage({
                defaultMessage: 'Products Carousel',
                id: 'global.carousel.products'
            })}
            ref={ref}
            {...props}
        />
    )
})
if (process.env.NODE_ENV !== 'production') {
    RecommendedProductsSliderImpl.displayName = 'RecommendedProductsSlider'
}
const RecommendedProductsSlider = withContext(RecommendedProductsSliderImpl, 'slider', {
    defaultProps: {
        variant: 'productCarousel'
    }
})
const RecommendedProductsTile = withContext(ProductTile, 'tile', {
    defaultProps: {
        dynamicImageProps: {
            widths: {base: '67vw', s: '25vw'}
        },
        variant: 'leap-reco'
    }
})

const RecommendedProducts = {
    Root: RecommendedProductsRoot,
    Label: RecommendedProductsLabel,
    Slider: RecommendedProductsSlider,
    Tile: RecommendedProductsTile
}

export default RecommendedProducts
